export const sentimentFilters = ['Relevant', 'Irrelevant', 'Both']
